import { Checkbox, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as DropdownIcon } from "../../../assets/svg/coolicon_down.svg";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import "./MultiSelectDropdown.scss";
interface MultiSelectDropdownProps {
  placeholder: string;
  displayPropertyName: string;
  valuePropertyName: string;
  value: string[];
  width?: string | number;
  canSearch?: boolean;
  searchFilterDropdownMenuList: any[];
  searchFilterDropdownPlaceholder: string;
  onChange?: (e: any) => void;
}
const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  placeholder,
  onChange,
  displayPropertyName,
  valuePropertyName,
  value,
  width = "260px",
  searchFilterDropdownMenuList,
  searchFilterDropdownPlaceholder,
  canSearch,
}) => {
  const [isNotSelected, setIsNotSelected] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filteredOptions, setFilteredOptions] = useState<any[]>(
    searchFilterDropdownMenuList
  );

  useEffect(() => {
    setFilteredOptions(searchFilterDropdownMenuList);
  }, [searchFilterDropdownMenuList]);

  useEffect(() => {
    if (searchTerm.length > 0 || searchTerm.length === 0) {
      setFilteredOptions(
        searchFilterDropdownMenuList.filter((item) =>
          item[displayPropertyName]
            ?.toLowerCase()
            ?.includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm, searchFilterDropdownMenuList]);

  useEffect(() => {
    setIsNotSelected(value.length === 0);
  }, [value, searchFilterDropdownMenuList]);
  const [title, setTitle] = useState<string>("");

  const handleChange = (e: any) => {
    let updatedValue = e.target.value;
    updatedValue = updatedValue.filter((element: any) => {
      return element !== undefined;
    });
    if (updatedValue?.toString() === "") {
      setTitle("");
      onChange && onChange([]);
      return;
    }
    let hoverText = "";
    for (let i = 0; i < updatedValue.length; i++) {
      const displayValue = searchFilterDropdownMenuList.find(
        (obj: any) => obj[valuePropertyName] === updatedValue[i]
      );
      if (displayValue != undefined) {
        hoverText = hoverText + ", " + displayValue[displayPropertyName];
      }
    }
    setTitle(hoverText.slice(1));
    onChange && onChange(updatedValue);
  };

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const renderValue = (selectedValue: string[]) => {
    if (selectedValue.length === 0)
      return <div className="placeholder">{placeholder}</div>;

    const displayValues = selectedValue.map((val) => {
      const displayValue = searchFilterDropdownMenuList.find(
        (obj: any) => obj[valuePropertyName] === val
      );
      return displayValue ? displayValue[displayPropertyName] : "";
    });
    let renderSelectedValues: string[] = [];
    renderSelectedValues.push(displayValues[0]);
    if (displayValues.length > 1) {
      renderSelectedValues.push(`+${displayValues.length - 1}`);
    }
    return (
      <div className="px-3 display-values d-flex">
        <span className="display-value">{renderSelectedValues[0]}</span>
        <span>{renderSelectedValues[1]}</span>
      </div>
    );
  };
  const clearAll = (e: any) => {
    setTitle("");
    setSearchTerm("");
    onChange && onChange([]);
    e.stopPropagation();
  };
  return (
    <span
      title={title}
      className="filter-container multi-select-dropdown pt-2 cursor-pointer px-2"
    >
      <FormControl fullWidth>
        <InputLabel
          shrink={false}
          id="grid-search"
          style={{
            fontSize: "14px",
            top: "-5px",
            color: "var(--primary-color)",
          }}
        >
          {isNotSelected && placeholder}
        </InputLabel>
        <Select
          labelId="grid-search"
          multiple
          MenuProps={{
            style: { maxWidth: "170px", maxHeight: "300px" },
          }}
          value={value}
          onOpen={() => setIsOpen(true)}
          onClose={() => {
            setIsOpen(false);
            setFilteredOptions(searchFilterDropdownMenuList);
            setSearchTerm("");
          }}
          renderValue={(selected) => renderValue(selected)}
          open={isOpen}
          onChange={handleChange}
          IconComponent={DropdownIcon}
          style={{
            height: "40px",
            width: width,
            border: "1px solid #dbdbdb",
          }}
          sx={{
            ".MuiSelect-outlined": {
              padding: "0px !important",
              maxHeight: "40px !important",
              minHeight: "40px !important",
              fontSize: "14px",
              minWidth: width,
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <div className="filter-dropdown-header">
            <div className="d-flex justify-content-end px-2">
              <button
                disabled={value?.length === 0}
                className="dropdown-button clear-all"
                onClick={clearAll}
              >
                Clear All
              </button>
            </div>
            {canSearch && (
              <input
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                value={searchTerm}
                autoFocus
                className="filter-search py-2 px-3"
                placeholder="Search"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )}
          </div>

          {filteredOptions.length > 0 ? (
            filteredOptions.map((val: any, index: number) => (
              <MenuItem
                className="multiselect"
                key={index}
                value={val[valuePropertyName]}
              >
                <Checkbox
                  checked={value.includes(val[valuePropertyName])}
                  size="small"
                />
                <span title={val[displayPropertyName]} className="select-value">
                  {val[displayPropertyName]}
                </span>
              </MenuItem>
            ))
          ) : (
            <div className="select-message">
              <span>No data to display</span>
            </div>
          )}
        </Select>
      </FormControl>
    </span>
  );
};

export default MultiSelectDropdown;
